module.exports = __webpack_public_path__ + "static/bannerpic1_r-460cefc31025373328a5ad3611894064.jpg";